<template>
  <Dialog v-if="user.hasCreateAccessToArea(areaAccessName)">
    <template #expander="{openModal}">
      <ButtonCustomized
        :label="`${hasUnsavedChanges ? 'Save & ' : ''} Create Another Playlist`"
        @click="openCreateAnotherPLaylistModal(openModal)"
      />
    </template>
    <template #dialog.title >Create Another Playlist</template>

    <template #dialog.content="{closeModal, closeModalAfter}">
      <CreatePlaylistForm
        @cancel="closeModal"
        @success="closeModalAfter(1000)"
      />
    </template>
  </Dialog>
</template>


<script lang="ts" setup>
import Dialog from '@/components/Dialog/Dialog.vue';
import ButtonCustomized from '@/components/form-fields/ButtonCustomized.vue';
import CreatePlaylistForm from '@/views/PlaylistsListView/CreatePlaylistForm/CreatePlaylistForm.vue';
import useUser from '@/composables/user';
import listNamesConfig from '@/views/PlaylistsListView/PlaylistsLister/config/listNames.config';
import usePlaylist from '../composables/playlist';
import sharedRefs from '../sharedRefs';

const user = useUser();
const { areaAccessName } = listNamesConfig;
const { hasUnsavedChanges } = usePlaylist();
const { savePlaylistButtonRef } = sharedRefs;

async function openCreateAnotherPLaylistModal( openModalCallback: Function ) {
  if(hasUnsavedChanges.value) {
    await savePlaylistButtonRef.value.savePlaylist();
  }
  setTimeout(openModalCallback, hasUnsavedChanges.value ? 1000 : 0);
}
</script>

<style lang="scss" scoped>

</style>